export default "__VITE_ASSET__DEmTS2G3__"